// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// locationInfoText (#657) — the notes the Location ℹ️ window shows for `location`.
// The window used to read one shared value that is wiped on every location switch and
// refilled only when the office lookup CHANGES — returning to an office already in
// memory could refill before the wipe and leave the window blank (or show another
// office's notes). Now: take the first office record that actually belongs to
// `location` (its `Location` field), from the given sources in order of preference.
// Pure, so the tests run exactly what the window runs.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

/**
 * @param {string} location — the office the window is showing
 * @param {...object} offices — candidate Offices docs (any may be null/undefined/{}), best first
 * @returns {string} that office's ScheduleInfo, or "" when no candidate belongs to it
 */
export function locationInfoText(location, ...offices) {
  if (!location) return "";
  const match = offices.find((o) => o && typeof o === "object" && o.Location === location);
  return match && typeof match.ScheduleInfo === "string" ? match.ScheduleInfo : "";
}
